import { takeLatest, put, call } from 'redux-saga/effects'
import jwt_decode from 'jwt-decode'
import { camelizeKeys } from 'humps'

import { getJWT } from 'helpers/cookies.helper'
import { redirectToExternalLogin } from 'helpers/loginRedirect.helper'
import { resolveUserAvatarUrl } from 'helpers/avatar.helper'
import { IUserModel } from 'models/user.model'
import canView from 'api/access/CanView'
import getMe from 'api/me/getMe'
import * as fromActions from '../../actions/user.action'

async function canViewLms() {
  return await canView()
}

async function fetchUserAvatar(): Promise<string | undefined> {
  try {
    const me = await getMe()
    return me.avatar || undefined
  } catch {
    return undefined
  }
}

function* decodeJwtEffectSaga() {
  try {
    const jwt = getJWT()
    if (jwt === '') {
      redirectToExternalLogin()
    } else {
      const viewResponse = yield call(canViewLms)
      if (viewResponse.canView) {
        const userData = camelizeKeys(jwt_decode(jwt)) as unknown as IUserModel
        const rawAvatar = yield call(fetchUserAvatar)
        const avatarUrl = resolveUserAvatarUrl(rawAvatar)
        yield put(
          fromActions.Actions.updateUser({ ...userData, avatar: avatarUrl })
        )
      } else {
        redirectToExternalLogin()
      }
    }
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* decodeJwtWatcherSaga() {
  yield takeLatest(fromActions.DECODE_JWT, decodeJwtEffectSaga)
}
